import { render, staticRenderFns } from "./ListStorages.vue?vue&type=template&id=56e14d7f&scoped=true"
import script from "./ListStorages.vue?vue&type=script&lang=js"
export * from "./ListStorages.vue?vue&type=script&lang=js"
import style0 from "./ListStorages.vue?vue&type=style&index=0&id=56e14d7f&prod&scoped=true&lang=css"
import style1 from "./ListStorages.vue?vue&type=style&index=1&id=56e14d7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e14d7f",
  null
  
)

export default component.exports